<template>
  <div class="text-center">
    <v-progress-circular
      :size="70"
      :width="7"
      :color="colors.primarycolor"
      indeterminate
    ></v-progress-circular>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import mixin from "@/mixin";
export default {
  name: "start-page",
  mixins: [mixin],
  created() {
    this.$router.push(
      this.isLoggedIn ? `${this.activeProfile.directory}/home` : "login"
    );
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "account/authenticated",
      activeProfile: "account/activeProfile",
    }),
  },
};
</script>
